var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("file-title-component", { attrs: { title: _vm.title } }),
      _vm._v(" "),
      _c("input", {
        ref: "fileInput",
        staticStyle: { visibility: "hidden" },
        attrs: { id: "fileInput", type: "file" },
        on: { change: _vm.fileChosen }
      }),
      _vm._v(" "),
      _vm.fileState === "file_uploaded" || _vm.fileState === "file_selected"
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _c(
                  "b-form-group",
                  {
                    staticClass: "o-label",
                    attrs: {
                      id: "filename-form-group",
                      label: _vm.$t("speeches.documents.filenameLabel"),
                      "label-for": "filename-input"
                    }
                  },
                  [
                    _c("b-form-input", {
                      staticClass: "o-form",
                      attrs: {
                        id: "filename-input",
                        type: "text",
                        required: "",
                        placeholder: "keine Datei vorhanden",
                        disabled: ""
                      },
                      model: {
                        value: _vm.localFile.name,
                        callback: function($$v) {
                          _vm.$set(_vm.localFile, "name", $$v)
                        },
                        expression: "localFile.name"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col button-div" },
          [
            _vm.fileState === "no_file_selected"
              ? _c(
                  "a",
                  {
                    attrs: { href: "javascript:void(0)" },
                    on: { click: _vm.openInput }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("speeches.documents.uploadButton")) +
                        "\n            "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.fileState === "file_uploaded"
              ? _c(
                  "b-button",
                  { staticClass: "o-button", on: { click: _vm.deleteFile } },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("speeches.documents.deleteButton")) +
                        "\n            "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.fileState === "file_uploaded"
              ? _c(
                  "b-button",
                  { staticClass: "o-button", on: { click: _vm.download } },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("speeches.documents.downloadButton")) +
                        "\n            "
                    )
                  ]
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "gap-div" }),
      _vm._v(" "),
      _c("div", { staticClass: "getter-hook" }, [_vm._v(_vm._s(_vm.localFile))])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-84aa5330", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84aa5330","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/funeral/FileUploadComponent.vue
// module id = null
// module chunks = 